// src/api/config.js
import axios from 'axios';

// Crear instancia de axios con configuración base
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  timeout: 10000, // 10 segundos de timeout
  headers: {
    'Content-Type': 'application/json'
  }
});

// Interceptor para agregar token y company-id automáticamente
api.interceptors.request.use(
  (config) => {
    // Agregar token
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;

      // Decodificar token para ver companyId (solo para debug)
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        if (config.url.includes('/contracts')) {
          console.log('🔑 Token companyId:', payload.companyId, '- Usuario:', payload.username);
        }
      } catch (e) {
        // Ignorar errores de decodificación
      }
    }

    // 🔥 AGREGAR COMPANY ID
    const companyId = localStorage.getItem('companyId');
    if (companyId) {
      config.headers['x-company-id'] = companyId;
      if (config.url.includes('/contracts')) {
        console.log('📦 localStorage companyId:', companyId);
      }
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para manejar respuestas
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Solo limpiar sesión si el token está genuinamente expirado
    if (error.response?.status === 401) {
      const token = localStorage.getItem('token');
      if (token) {
        try {
          // JWT usa base64url: reemplazar - por + y _ por / antes de decodificar
          const base64Url = token.split('.')[1];
          const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
          const padded = base64.padEnd(Math.ceil(base64.length / 4) * 4, '=');
          const payload = JSON.parse(atob(padded));
          const isExpired = payload.exp && payload.exp * 1000 < Date.now();
          if (isExpired) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            localStorage.removeItem('companyId');
          }
          // Si NO está expirado, conservar el token — el 401 es por otra razón
        } catch (e) {
          // Si no se puede decodificar, conservar el token (no borrar por error de parsing)
        }
      }
    }
    return Promise.reject(error);
  }
);

export default api;
